import React          from 'react';
import classNames     from 'classnames';
import * as PropTypes from 'prop-types';

export const RenderRadio = ({ ...props }) => {
  const {
          checked,
          count,
          disabled,
          label,
          onChange,
          onClick,
        } = props;

  return (
    <div
      className={classNames(
        'radio',
        { checked, disabled },
      )}
      onClick={disabled ? undefined : onClick}
    >
      <label>
        <input
          type={'radio'}
          checked={checked}
          disabled={disabled}
          onChange={event => {
            const { target: { value } } = event;

            if (typeof onChange === 'function') {
              onChange(value);
            }
          }}
        />
        <span className={'ic-radio'} />
        <span className={'radio-label'}>{label}</span>
        {typeof count === 'number' && <span className={'facet-count'}>({count})</span>}
      </label>
    </div>
  );
};

RenderRadio.propTypes = {
  checked:  PropTypes.bool.isRequired,
  count:    PropTypes.number,
  disabled: PropTypes.bool,
  label:    PropTypes.string,
  onChange: PropTypes.func,
  onClick:  PropTypes.func,
};